"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisclaimerModal = void 0;
const react_1 = __importStar(require("react"));
const disclaimer_1 = require("./disclaimer");
const close_button_1 = require("./close-button");
const styled_1 = require("./styled");
const use_modal_disclaimer_1 = require("./use-modal-disclaimer");
const DisclaimerModal = props => {
    const { disclaimers } = props;
    const { active, activeNumber } = (0, use_modal_disclaimer_1.useModalDisclaimer)();
    const closeModalDisclaimer = (0, use_modal_disclaimer_1.useCloseModalDisclaimer)();
    const [activeDisclaimer, setActiveDisclaimer] = (0, react_1.useState)(undefined);
    (0, react_1.useEffect)(() => {
        if (active && activeNumber) {
            let selectedDisclaimer = disclaimers === null || disclaimers === void 0 ? void 0 : disclaimers.find((disclaimer) => {
                return activeNumber.includes(disclaimer.number || '');
            });
            if (!selectedDisclaimer) {
                selectedDisclaimer = {
                    token: 'undefined',
                    number: '*',
                    description: 'Ops! There is not a description for this disclaimer'
                };
            }
            setActiveDisclaimer(selectedDisclaimer);
        }
    }, [active, activeNumber]);
    const disclaimerLayerRef = (0, react_1.useRef)(null);
    /**
     * Hide dropdown option box when user is interacting with another component
     * @param event
     */
    const handleClickOut = (event) => {
        var _a;
        !((_a = disclaimerLayerRef === null || disclaimerLayerRef === void 0 ? void 0 : disclaimerLayerRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target)) &&
            closeModalDisclaimer &&
            closeModalDisclaimer();
    };
    (0, react_1.useEffect)(() => {
        if (typeof window !== 'undefined') {
            document.addEventListener('mousedown', handleClickOut, false);
        }
        return () => {
            if (typeof window !== 'undefined') {
                document.removeEventListener('mousedown', handleClickOut, false);
            }
        };
    }, []);
    return active && activeDisclaimer ? (react_1.default.createElement(styled_1.StyledDisclaimerModal, { className: "disclaimer-modal-container" },
        react_1.default.createElement(styled_1.StyledDisclaimerLayer, { className: "disclaimer-modal-layer layer-animation", ref: disclaimerLayerRef },
            react_1.default.createElement(styled_1.StyledDisclaimerContainer, { className: "disclaimer-text-container" },
                react_1.default.createElement(disclaimer_1.DisclaimerLine, Object.assign({}, activeDisclaimer, { colorInherit: true }))),
            react_1.default.createElement(close_button_1.CloseButton, { onClickHandle: closeModalDisclaimer })))) : (react_1.default.createElement(react_1.default.Fragment, null));
};
exports.DisclaimerModal = DisclaimerModal;
